import { LOCALES } from 'state/intl/types';
import logger from 'utils/logger';

const localeImport: Record<string, () => Promise<any>> = {
  [LOCALES.en_us]: () => import(`@formatjs/intl-listformat/locale-data/en-US`),
};

export const polyfillListFormatLocale = async (locale: LOCALES) => {
  try {
    const importLocale = localeImport[locale];
    if (importLocale) {
      await importLocale();
    } else {
      await import('@formatjs/intl-listformat/locale-data/en-US');
    }
  } catch (e) {
    logger.warn(e as any);
  }
};
